const Desc = `documentManifest: Get document manifest for PSD in CC. PSD contains smart object filter. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [{
        href: 'files/_skycity_smoketest/smartObject_filter.psd',
        storage: 'adobe'
    }],
    options: {
        thumbnails: {
            type: 'image/png'
        }
    }
}

module.exports = { Desc, Payload }
